import { makeStyles } from '@material-ui/core/styles';

const avatarWidth = 140;

export default makeStyles(() => ({
  root: {
    margin: 10,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  avatar: {
    height: avatarWidth,
    width: avatarWidth,
    
  },
}));
